import * as React from 'react';

import cn from 'classnames';

import { Icon } from '@components/Icon';

import { IconLogo } from '@icons';

import { IDmcaPageProps } from '../../types';

import * as s from './DmcaHeader.scss';

const DmcaHeaderComponent = ({
	classNames: {
		content: contentClassName,
	},
}: IDmcaPageProps) => {
	return (
		<div className={s.block}>
			<div className={cn(s.content, contentClassName)}>
				<Icon glyph={IconLogo} className={s.logo} />
			</div>
		</div>
	);
};

export const DmcaHeader = React.memo(DmcaHeaderComponent, () => true);
